import { atom } from 'recoil'
import { makeDateAdapterFactory } from '@/main/adapters'

export const dateAdapterAtom = atom({
  key: 'dateAdapterState',
  default: makeDateAdapterFactory()
})
